// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2YjX1","rootSmall":"AddTileButton_rootSmall__EdAFf"};